import { DefaultDataPoint, FontSpec, ChartData, ChartDataset } from 'chart.js';
import { defaultsDeep } from 'lodash';

import { ChartConfigBuilder, ChartDatasetConfigBuilder } from './chart-config.model';
import { baseChartConfig, baseDatasetConfig } from './chart-base.config';

export const defaultChartConfig: ChartConfigBuilder<'line', DefaultDataPoint<'line'>> & {priority?: number} = (title?: string) => {
    return defaultsDeep({
        options: {
            plugins: {
                title: {
                    text: title,
                    fullSize: true,
                    font: () => <FontSpec>{ family : 'roboto'}
                },
            },
            
            scales: {
                y: {
                    beginAtZero: true,
                },
            },

        },
    }, baseChartConfig(title));
};

export const defaultDatasetConfig: ChartDatasetConfigBuilder = (datasets: ChartDataset[]) => {
    return defaultsDeep(
        <ChartData<'line', DefaultDataPoint<'line'>, unknown>> {
            datasets: datasets.map((dataset: ChartDataset) => ({
                ...dataset,
            })),
        },
        baseDatasetConfig(datasets),
    );
}